var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides__x26__Forms"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,13V7.369L21.899,9.47c-1.537-1.54-3.657-2.495-6.005-2.495c-4.694,0-8.5,3.806-8.5,8.5s3.806,8.5,8.5,8.5   c3.159,0,5.91-1.727,7.375-4.286l-1.737-0.993c-1.122,1.955-3.226,3.278-5.638,3.278c-3.584,0-6.5-2.916-6.5-6.5   c0-3.584,2.916-6.5,6.5-6.5c1.792,0,3.414,0.732,4.59,1.91L18.369,13H24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.2c23dd36ed44f1d321129c1bb5dd53c7.svg";
export { ForwardRef as ReactComponent };